import d3 from "d3";

const capitalizeFirstLetter = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const generateTooltipFunctions = function () {
  // Append elements to DOM to build tooltip
  const tooltip = d3.select("body")
                    .append("div")
                    .attr("class", "sankey-tooltip")
                    .style("opacity", "0")
                    .style("z-index", 999999);
  const tooltip_title = tooltip.append("p")
                               .attr("class", "tooltip-title");
  const tooltip_type = tooltip.append("p")
                              .attr("class", "tooltip-type");
  const tooltip_revenue_text = tooltip.append("p")
                                      .attr("class", "tooltip-body");
  const tooltip_body = tooltip.append("p")
                              .attr("class", "tooltip-body");
  const tooltip_instruction = tooltip.append("p")
                                     .attr("class", "tooltip-instruction");

  const nodeGroupMouseover = function(event, d) {
    // ...highlight circle
    d3.select(this)
      .select("circle")
      .classed("active", true);
    // ...make tooltip visible
    tooltip.attr("class", "sankey-tooltip sankey-" + d.type)
           .transition()
           .duration(200)
           .style("opacity", "1");
    // ... and position tooltip, style and add text (v6: event is the handler's first arg)
    const leftValue = (event.clientX + 50);
    const topValue = (event.clientY - 28);
    tooltip.style("left", leftValue + "px")
           .style("top", topValue + "px");
    // if description, show it
    tooltip_body.html(d.description)
                .style("display", function() {
                  return !d.description ? "node" : "block";
                });
    tooltip_title.html(d.name);
    tooltip_revenue_text.html(d.revenue_text);
    const tooltipType = d.type
                         .replace("lead", "This company")
                         .replace("other-businesses", "")
                         .replace("legacy-brand", "Legacy brand")
                         .replace("parent", "Parent / shareholder")
                         .replace("associate", "Associated company");

    tooltip_type.html(capitalizeFirstLetter(tooltipType))
                .attr("class", "tooltip-type sankey-" + d.type);
    // if company has a path defined, add text to say they can click for more info
    tooltip_instruction.html("Click on the company node for more information")
                       .style("display", function() {
                         return !d.path ? "none" : "block";
                       });
  };
  const nodeGroupMouseout = function () {
    d3.select(this)
      .select("circle")
      .classed("active", false);
    tooltip.transition()
           .delay(100)
           .duration(200)
           .style("opacity", "0");
  };

  return { nodeGroupMouseover, nodeGroupMouseout };
};

export default generateTooltipFunctions;
